import godzilla from '../assets/brand/godzilla.webp';
import { contacts, siteLinks } from '../data.js';
import { ArrowUpRightIcon, MailIcon } from '../components/Icons.jsx';

export function AboutPage() {
  return (
    <>
      <header className="page-hero page-width">
        <div>
          <p className="eyebrow">The show</p>
          <h1>Making spirits bright.<br />Not suitable for any audience.</h1>
        </div>
        <p>
          Foul and fun, alarming and charming, Uncle Mike Ruins Christmas is a Seattle-grown improvised holiday tradition since 2007.
        </p>
      </header>

      <section className="about-feature page-width">
        <div className="about-art">
          <img src={godzilla} alt="Uncle Mike as Godzilla stomping through a Christmas village" />
        </div>
        <div className="about-story">
          <p className="eyebrow">You better not cry</p>
          <h2>A cherished memory is improved through Uncle Mike holiday magicks.</h2>
          <p>
            Audience members write down heartwarming holiday memories. The narrator chooses the memories, the cast re-enacts it, and then unleashes Uncle Mike to destroy it in ways no sane human should be able to imagine.
          </p>
          <p>
            Every performance is different. Improvised from your cherished holiday memories. Every memory is defiled.
          </p>
          <div className="warning-card">
            <span>18+</span>
            <p>This improvised show features mature content and is not suitable for anyone.</p>
          </div>
        </div>
      </section>

      <section className="details-band">
        <div className="page-width details-grid">
          <div><span>Format</span><strong>Improv & Magic</strong></div>
          <div><span>Origin</span><strong>Seattle, WA</strong></div>
          <div><span>Holiday cheer</span><strong>Perverse</strong></div>
          <div>
            <span>Venue</span>
            <a href={siteLinks.theatreUrl} target="_blank" rel="noreferrer">
              View theatre <ArrowUpRightIcon />
            </a>
          </div>
        </div>
      </section>

      <section className="contact-section page-width section-pad">
        <div>
          <p className="eyebrow">Get in touch</p>
          <h2 className="display-heading">Harass us here<br />send nudes</h2>
        </div>
        <div className="contact-list">
          {contacts.map((contact) => (
            <a key={contact.email} href={`mailto:${contact.email}`}>
              <span><MailIcon /> {contact.label}</span>
              <strong>{contact.email}</strong>
            </a>
          ))}
        </div>
      </section>
    </>
  );
}
